export default {
  anyMistakes:
    'If you believe any information on this page is incorrect then please',
  contactUs: 'contact us',
  social: "We're social | Follow us",
}
